const DEFAULT_TIMEOUT_MS = 8000;

/**
 * Resolves once the browser has loaded `src`, failed to load it, or the timeout passes.
 * Swapping an <img> to an already-loaded URL shows it immediately, without a blank or fallback frame.
 * Never rejects: callers show the new image either way.
 */
export const waitForImage = (src: string, timeoutMs = DEFAULT_TIMEOUT_MS): Promise<void> =>
  new Promise((resolve) => {
    const image = new window.Image();
    const timeout = window.setTimeout(finish, timeoutMs);
    function finish() {
      window.clearTimeout(timeout);
      image.onload = null;
      image.onerror = null;
      resolve();
    }
    image.onload = finish;
    image.onerror = finish;
    image.src = src;
  });
